import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';

export const accountLanguageSchema = z.object({
  accountId: z.number(),
  languageId: z.string(),
  lastModifienOn: coercedDate.optional(),
});

export type AccountLanguage = z.infer<typeof accountLanguageSchema>;
